import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import dayjs from 'util/dayjs-init.js';
import { Box, TextField, Typography, useTheme } from "@mui/material";
import localizationKeys from "../../../i18n/localizationKeys.js";
import { Autocomplete } from '@mui/material';
import * as PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { alarmSearch, placeHolder } from "./searchDesign.jsx";

const column = {
  fontSize: "12px",
  fontFamily: "Inter",
  fontWeight: "500",
  color: "#ffffff",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
};

const useStyles = ({ isOperationPage, theme }) =>
  ({
    searchBase: {
      flexGrow: 1,
      "& .first-child": {
        marginRight: "auto",
      },
      "& .MuiAutocomplete-popper": {
        backgroundColor: "none !important",
      },
      [theme.breakpoints.down('sm')]: {
        width: "100%",
        marginLeft: "0",
      },
    },
    searchIconAdjustment: {
      marginRight: "5px",
    },
    item: {
      //display: "flex",
      alignItems: "left",
      justifyContent: "flex-start",
      width: "100%",
      height: "100%",
      [theme.breakpoints.down('sm')]: {
        display: "block",
      },
    },
    columnName: {
      ...column,
      [theme.breakpoints.up("sm")]: {
        //marginLeft: "auto",
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: "10px !important",
      },
    },
    titleContainer: {
      width: isOperationPage ? "110px" : "80px",
      display: "flex",
      margin: "4px 0px",
      [theme.breakpoints.down('sm')]: {
        width: "100%",
        marginBottom: "12px",
      },
    },
  });

const SearchValue = React.memo(
  ({ isOperationPage, text, setText, autocompleteOptions, i18n, t, resetFunc }) => {
    const theme = useTheme();
    const classes = useStyles({ isOperationPage, theme });
    const [key, setKey] = useState("");
    const { register, getValues, setValue, watch, reset } = useForm({
      defaultValues: {
        value: "",
      },
    });

    resetFunc.current = () => {
      reset();
      setKey(dayjs.utc().toString());
    };

    useEffect(() => {
      setValue("value", text);
    }, []);

    useEffect(() => {
      setText(getValues().value);
    }, [watch("value")]);

    return (
      <Box sx={classes.item} key="input-base">
        <Box sx={classes.titleContainer}>
          <Typography sx={classes.columnName} variant="body2">
            {t(isOperationPage ? localizationKeys.Status_lower : localizationKeys.Value_lower)}
          </Typography>
        </Box>
        <Autocomplete
          name="value"
          key={key}
          freeSolo
          options={autocompleteOptions()}
          {...register("value")}
          onInputChange={(e, v, r) => {
            setValue("value", v);
          }}
          sx={classes.searchBase}
          disableClearable
          renderInput={(params) => (
            <TextField
              {...params}
              key="input-text"
              sx={{ ...alarmSearch(theme)}}
              placeholder={t(localizationKeys.Search_lower)}
              variant="standard"
              slotProps={{
                input: {
                  ...params.InputProps,
                  type: "search",
                }
              }}
            />
          )}
        />
      </Box>
    );
  }
);

SearchValue.propTypes = {
  isOperationPage: PropTypes.bool,
  text: PropTypes.string,
  setText: PropTypes.func,
  t: PropTypes.func,
  autocompleteOptions: PropTypes.func,
  i18n: PropTypes.object,
};

export default withTranslation()(SearchValue);
